import { PlatformTypeEnum } from '@/common/constants';
import Filter from '@/components/filter/Filter';
import { Sidebar } from '@/components/sidebar';
import { ScrollArea } from '@/components/ui/scroll-area';
import { useLoadStore } from '@/features/loads/store';
import { usePartyStore } from '@/features/parties/store/usePartyStore';
import useStore from '@/lib/store';
import { FC, useEffect, useMemo, useState } from 'react';
import { Outlet, useParams, useSearchParams } from 'react-router-dom';
import { NavbarMeasure } from './navbar';

export const LoadWrapper: FC = () => {
  const { user } = useStore();
  const { status = 'ALL', id } = useParams();
  const [searchParams] = useSearchParams();
  const [open, setOpen] = useState(false);
  const isCotton = user?.platform_type === PlatformTypeEnum.COTTON;
  const {
    loadListLoading,
    fetchLoadList,
    fetchLoadGrainList,
    loadGrainListLoading,
  } = useLoadStore();
  const { fetchParties } = usePartyStore();

  const size = Number(searchParams.get('size')) || 20;
  const page = Number(searchParams.get('page')) || 1;
  const tax_number = Number(searchParams.get('tax_number')) || undefined;
  const cluster_id = searchParams.get('cluster_id') || undefined;
  const id_number = Number(searchParams.get('id_number')) || undefined;
  const farmer_name = searchParams.get('farmer_name') || undefined;
  const date = searchParams.get('date') || undefined;

  const filters = useMemo(
    () => ({
      page,
      size,
      cluster_id,
      tax_number,
      id_number,
      farmer_name,
      date,
    }),
    [page, size, tax_number, id_number, farmer_name, date, cluster_id],
  );

  const payload = useMemo(
    () =>
      status === 'ALL'
        ? filters
        : {
            has_analysis: status === 'NOT_FILLED' ? false : true,
            ...filters,
          },
    [status, filters],
  );

  useEffect(() => {
    fetchParties();
  }, []);

  useEffect(() => {
    if (isCotton) {
      fetchLoadList(payload);
    } else {
      fetchLoadGrainList(payload);
    }
  }, [fetchLoadList, payload, fetchLoadGrainList, isCotton]);

  return (
    <div className="flex flex-col">
      <NavbarMeasure />

      <div className="flex">
        <Sidebar />

        <ScrollArea className="w-full h-[calc(100vh-105px)]">
          <Filter
            isOpen={open}
            setIsOpen={setOpen}
            isLoading={isCotton ? loadListLoading : loadGrainListLoading}
          />
          <Outlet key={id} />
        </ScrollArea>
      </div>
    </div>
  );
};
